/**
 * ch_grouper
 *
 * controls grouper related lead gen, modals, etc
 *
 * Originally this was geared *just* towards Grouper but eventually
 * Came to be used for generic "group/private" lead gen
 */
define('ch_grouper',[
    'ch_ga',
    'jquery',
    'sweetalert', // swal
    'semantic',
], function (ga, $, swal) {
    function getCourseInfo() {
        if (window.CH && window.CH.coursePage && window.CH.coursePage.courseId) {
            return {
                id: window.CH.coursePage.courseId,
                name: window.CH.coursePage.courseName,
            };
        }
        return false;
    }

    /**
     * initializes a modal which prompts the user for "request to book" specific questions
     *
     * this is intended for use only on a course page
     *
     * @param triggerElementSelector
     */
    function initializeGrouperRequestToBookModal(triggerElementSelector) {
        const $modal = $('#grouper-request-to-book-modal');

        if (!$modal.length) {
            return;
        }

        const $form = $('.ui.form', $modal);
        // disable standard submits in favor of a static button we're using
        $form.on('submit', e => e.preventDefault());

        // set up field behaviors
        $('.dropdown', $form)
            .dropdown();

        let currentCourse = getCourseInfo();
        if (currentCourse) {
            $modal.find('.js-course-name').html(currentCourse.name);
            $form.find('input[name=course_name]').val(currentCourse.name);
            $form.find('input[name=course_id]').val(currentCourse.id);
        }

        // set up validation
        $form.form({
            on: 'change',
            inline: true,
            fields: {
                name: {
                    rules: [
                        {
                            type: 'empty',
                            prompt: 'Please enter your name.',
                        },
                    ],
                },
                email: {
                    rules: [
                        {
                            type: 'empty',
                            prompt: 'Please enter your email.',
                        },
                        {
                            type: 'email',
                            prompt: 'Please enter a valid email.',
                        },
                    ],
                },
                group_size: {
                    rules: [
                        {
                            type: 'empty',
                            prompt: "Please enter your group's size.",
                        },
                        {
                            type: 'integer[1..100]',
                            prompt: 'Please only enter numbers from 1 to 100.',
                        },
                    ],
                },
                notes: {
                    rules: [
                        {
                            type: 'maxLength[255]',
                            prompt: 'Please keep this shorter than 255 characters.',
                        },
                    ],
                },
                dates_and_times: {
                    rules: [
                        {
                            type: 'maxLength[255]',
                            prompt: 'Please keep this shorter than 255 characters.',
                        },
                    ],
                },
            },
            onSubmit: e => e.preventDefault(),
        });

        $(triggerElementSelector)
            .on('click', (e) => {
                e.preventDefault();
                // newer event versus "viewed nav site pop-up"
                triggerEventOnElement(e.currentTarget);
                triggerModal(
                    $modal,
                    $form,
                    e.currentTarget.href,
                    e.currentTarget.dataset.gaEvent,
                    {
                        title: 'Thank you!',
                        text: 'We\'ll be in touch within 2 business hours with pricing and availability information.',
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        closeOnEsc: true,
                        allowOutsideClick: true,
                    }
                );
            });
    }

    function initializeGrouperIntentModal(triggerElementSelector) {
        const $modal = $('#grouper-intent-modal');

        if (!$modal.length) {
            return;
        }

        const $form = $('.ui.form', $modal);

        $form.form({
            on: 'change',
            inline: true,
            fields: {
                group_size: {
                    rules: [
                        {
                            type: 'empty',
                            prompt: "Please enter your group's size.",
                        },
                        {
                            type: 'integer[1..100]',
                            prompt: 'Please only enter numbers from 1 to 100',
                        },
                    ],
                },
            },
            onSubmit: e => e.preventDefault(),
        });

        $('.dropdown', $form)
            .dropdown();

        // grouper cta that displays the grouper intent modal
        // expects a "data-ga-event" attribute, which is sent to GA when user submits the modal
        // and a "data-ga-cta-label" attribute, which is used when the user clicks the CTA that opens the modal
        $(triggerElementSelector)
            .on('click', (e) => {
                e.preventDefault();
                // newer event versus "viewed nav site pop-up"
                triggerEventOnElement(e.currentTarget);
                triggerModal(
                    $modal,
                    $form,
                    e.currentTarget.href,
                    e.currentTarget.dataset.gaEvent
                );
            });
    }

    /**
     * triggerModal
     *
     * Display a given grouper modal
     * When modal is "approved" we'll submit the related form
     * Trigger necessary GA events, too
     *
     * @param $modal
     * @param $form
     * @param currentUrl
     * @param gaEvent
     * @param swalConfig
     */
    function triggerModal($modal, $form, currentUrl, gaEvent, swalConfig) {
        // @deprecated event
        // kept around for continuity for Katie while testing Grouper (Feb 11 2020)
        ga(
            'send',
            'event',
            'Grouper',
            'viewed nav site pop-up',
            window.location.pathname,
            { nonInteraction: false }
        );

        $modal
            .modal({
                onShow: () => {
                    $form.form('reset');
                },
                onApprove: () => {
                    let isFormValid = $form.form('is valid');
                    if (!isFormValid) {
                        $form.form('validate form');
                        return false;
                    }
                    let currentCourse = getCourseInfo();
                    let viewingCourseId = (currentCourse && currentCourse.id) || 'NA';
                    let formData = $form.form('get values');
                    let groupSize = formData.group_size;
                    formData.email = formData.email ? formData.email.trim() : formData.email;
                    let [url, search = ''] = currentUrl.split('?');
                    let gaAction = `${window.location.pathname} - ${viewingCourseId};${groupSize}`;

                    search = search.split('&');
                    search.push(`groupSize=${groupSize}`);

                    // If the user is currently viewing a category browse page
                    // we want to preserve that too
                    if (CH && CH.activeMainCategoryId) {
                        search.push(`categories=${CH.activeMainCategoryId}`);
                    }

                    formData.url = window.location.pathname + window.location.search;

                    $.ajax('/user/subscription/grouper-intent', {
                        method: 'POST',
                        data: formData,
                    })
                        .done(() => {
                            ga(
                                'send',
                                'event',
                                'Grouper',
                                gaEvent,
                                gaAction,
                                { nonInteraction: false }
                            );

                            if (swalConfig) {
                                // sometimes... we'll show a thank you
                                swal(swalConfig, function () {
                                    sendToPostSubmitUrl(url + '?' + search.join('&'));
                                });
                            } else {
                                // other times... we'll send them directly to grouper
                                sendToPostSubmitUrl(url + '?' + search.join('&'));
                            }
                        });
                    return true;
                },
                onHide: () => {
                    ga(
                        'send',
                        'event',
                        'Grouper',
                        'dismissed nav site pop-up',
                        window.location.pathname,
                        { nonInteraction: false }
                    );
                },
            })
            .modal('show');
    }

    function triggerEvent(gaAction, nonInteraction = false) {
        let gaLabel = window.location.pathname;
        let course = getCourseInfo();

        if (course && course.id) {
            gaLabel += ' - ' + course.id;
        }

        ga(
            'send',
            'event',
            'Grouper',
            gaAction,
            gaLabel,
            { nonInteraction: nonInteraction }
        );
    }

    /**
     * Send user on their way
     * Originally this sent a user to a Grouper browse page w/ search params
     *
     */
    function sendToPostSubmitUrl() {
        return false;
    }

    /**
     * Trigger a Grouper CTA GA Event for a given element
     * expects element to define:
     *  data-ga-cta-label
     *
     * Ga Event:
     *  Category: Grouper
     *  Action: CTA ${data-ga-event}
     *  Label: ${URL}-${COURSE_ID_IF_AVAILBLE}
     *
     * @param element
     * @param nonInteraction
     */
    function triggerEventOnElement(element, nonInteraction = false) {
        let gaAction = element.dataset.gaCtaLabel || 'CTA ...';

        triggerEvent(gaAction, nonInteraction);
    }

    return {
        triggerEventOnElement,
        triggerEvent,
        initializeGrouperIntentModal,
        initializeGrouperRequestToBookModal,
    };
});

